import React, { useState } from 'react';
import { FaPlus, FaTimes } from 'react-icons/fa';

/**
 * Capabilities Editor
 * - Add/remove capabilities dynamically
 * - Common capability suggestions
 */
const CapabilitiesEditor = ({ capabilities, onChange }) => {
  const [inputValue, setInputValue] = useState('');

  const commonCapabilities = [
    'file_operations',
    'database_access',
    'api_integration',
    'code_execution',
    'web_scraping',
    'data_processing',
    'notifications',
    'authentication',
    'search',
    'caching',
  ];

  const addCapability = (capability) => {
    const trimmed = capability.trim();
    if (trimmed && !capabilities.includes(trimmed)) {
      onChange([...capabilities, trimmed]);
      setInputValue('');
    }
  };

  const removeCapability = (capability) => {
    onChange(capabilities.filter((c) => c !== capability));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addCapability(inputValue);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    if (!capabilities.includes(suggestion)) {
      onChange([...capabilities, suggestion]);
    }
  };

  return (
    <div>
      {/* Current Capabilities */}
      {capabilities.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-3">
          {capabilities.map((capability) => (
            <span
              key={capability}
              className="px-3 py-1 bg-cyan-100 text-cyan-800 dark:bg-cyan-900/30 dark:text-cyan-400 rounded-full text-sm font-semibold inline-flex items-center gap-2"
            >
              {capability}
              <button
                type="button"
                onClick={() => removeCapability(capability)}
                className="hover:text-cyan-900 dark:hover:text-cyan-300"
              >
                <FaTimes />
              </button>
            </span>
          ))}
        </div>
      )}

      {/* Input */}
      <div className="flex gap-2">
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Add a capability..."
          className="flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 dark:bg-spooky-bg-medium dark:text-spooky-ghost-white"
        />
        <button
          type="button"
          onClick={() => addCapability(inputValue)}
          disabled={!inputValue.trim()}
          className="px-4 py-2 bg-cyan-500 text-white rounded-lg hover:bg-cyan-600 transition disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center gap-2"
        >
          <FaPlus />
          Add
        </button>
      </div>

      {/* Common Suggestions */}
      <div className="mt-3">
        <p className="text-xs text-gray-500 dark:text-gray-400 mb-2">
          Common capabilities:
        </p>
        <div className="flex flex-wrap gap-2">
          {commonCapabilities.map((suggestion) => (
            <button
              key={suggestion}
              type="button"
              onClick={() => handleSuggestionClick(suggestion)}
              disabled={capabilities.includes(suggestion)}
              className="px-3 py-1 text-xs border border-cyan-300 dark:border-cyan-700 text-cyan-600 dark:text-cyan-400 rounded-full hover:bg-cyan-50 dark:hover:bg-cyan-900/20 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {suggestion}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CapabilitiesEditor;
